/**
 * 各端 WebView汇总：https://alidocs.dingtalk.com/i/nodes/2X3LRMZdxkAJpxQdD6byJGgrBYeOq5Ew
 */
var _a, _b, _c;
// 判断运行环境是否是浏览器环境
export const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
// 判断运行环境是否是 nodejs 环境
export const isNode = 
// @ts-expect-error
typeof process !== "undefined" &&
    // @ts-expect-error
    process.versions != null &&
    // @ts-expect-error
    process.versions.node != null;
// 判断运行环境是否是web worker
export const isWebWorker = typeof self === "object" &&
    self.constructor &&
    self.constructor.name === "DedicatedWorkerGlobalScope";
export const ua = isBrowser ? navigator.userAgent : "nodejs";
/**
 * [2022-05-27]
 *【已废弃】【已废弃】已废弃，不推荐使用！！（但不能移除，担心影响旧版本）
 * ==> 因为 isIOS 这个名称有很大的歧义，是判断苹果手机浏览器，还是苹果手机迅雷。(通常是判断苹果手机浏览器环境，但这里居然是判断苹果手机迅雷)
 * 所以如果要判断苹果手机浏览器环境，请使用：isIOSDevice；如果是判断苹果手机迅雷浏览器环境，请使用：isIOSNative
 */
export const isIOS = /(iPhone|iPad).* iThunder/i.test(ua);
/**
 * 判断是不是 iOS 系统浏览器环境
 */
export const isIOSDevice = isBrowser ?
    (/iPad|iPhone|iPod/i.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) : false;
/**
 * 判断 iOS 手机迅雷 webview 环境
 */
export const isIOSNative = isBrowser ?
    isIOS &&
        !!window.WebViewJavascriptBridge &&
        !!window.WebViewJavascriptBridge.callHandler : false;
/**
 * iOS 手机迅雷内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isIOSAppWebView = isIOSNative && !/Browser/i.test(ua);
export const isIOSAppBrowserWebView = isIOSNative && /Browser/i.test(ua);
/**
 * 判断 iOS 手机X浏览器APP的浏览器环境
 */
export const isIOSXBrowserNative = isBrowser ? isIOSDevice && /xl_browser/i.test(ua) : false;
/**
 * iOS 手机X浏览器APP内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isIOSXBrowserAppWebView = isIOSXBrowserNative && /xl_browser/i.test(ua);
// TODO: 暂时无法判断
export const isIOSXBrowserAppBrowserWebView = false;
// ===================================================================================================================
/**
 * [2022-05-27]
 *【已废弃】【已废弃】已废弃，不推荐使用！！（但不能移除，担心影响旧版本）
 * ==> 因为 isAndroid 这个名称有很大的歧义，是判断Android手机浏览器，还是Android手机迅雷。(通常是判断Android手机浏览器环境，但这里居然是判断Android手机迅雷)
 * 而且兴广也进行了备注：内置新版浏览器没有这个标识，但有XLJSWebViewBridge 和 XLAccountJsBridge,所以需要从native api来判断最准确
 * 所以如果要判断Android手机浏览器环境，请使用：isAndroidDevice；如果是判断Android手机迅雷浏览器环境，请使用：isAndroidNative
 */
export const isAndroid = / Android .* iThunder/i.test(ua);
/**
 * 判断是不是 Android 系统浏览器环境
 */
export const isAndroidDevice = /Android/i.test(ua);
/**
 * 判断 Android 手机迅雷浏览器环境
 */
export const isAndroidNative = isBrowser ? isAndroidDevice && !!window.XLJSWebViewBridge : false;
/**
 * Android 手机迅雷内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isAndroidAppWebView = isAndroidNative && /iThunder/i.test(ua);
export const isAndroidAppBrowserWebView = isAndroidNative && !/iThunder/i.test(ua);
/**
 * 判断 Android 手机X浏览器APP的浏览器环境
 */
export const isAndroidXBrowserNative = isBrowser ? isAndroidDevice && (!!window.XBrowser_XLJSWebViewBridge || (!!window.XLJSWebViewBridge && /xl_browser/i.test(ua))) : false;
/**
 * Android 手机X浏览器APP内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isAndroidXBrowserAppWebView = isAndroidXBrowserNative && /xl_browser/i.test(ua);
export const isAndroidXBrowserAppBrowserWebView = isAndroidXBrowserNative && !/xl_browser/i.test(ua);
// ====================================================================================================================
/**
 * 【已废弃】【已废弃】已废弃，不推荐使用！！已废弃，不推荐使用！！但不能移除，担心影响旧版本。
 * ==> 同样因为 isMac 这个名称有很大的歧义，是判断 mac 系统浏览器，还是 mac 迅雷。(通常是判断 mac 浏览器环境，但这里居然是判断 mac 迅雷)
 * navigator.maxTouchPoints 不准确（之前兴广的注释）
 * 注：navigator.platform 会被废弃，尽早不再使用
 */
export const isMac = isBrowser ?
    navigator.platform === 'MacIntel' && / Mac .* MacThunder/.test(ua) : false;
/**
 * 判断是不是 mac 电脑设备
 * https://stackoverflow.com/questions/10527983/best-way-to-detect-mac-os-x-or-windows-computers-with-javascript-or-jquery
 * macppc|mac68k 的设备太老了，故移除
 */
export const isMacDevice = /(macintosh|macintel)/i.test(ua);
const isMacApp = isBrowser ?
    isMacDevice &&
        !!window.WebViewJavascriptBridge &&
        !!window.WebViewJavascriptBridge.callHandler : false;
/**
 * Mac迅雷内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isMacAppWebView = isMacApp && /MacThunder/i.test(ua);
export const isMacAppBrowserWebView = isMacApp && /ThunderBrowser/i.test(ua);
/**
 * [2022-12-19]
 * Mac迅雷内，运行在App WebView 或 Browser WebView中 即为MacNative。
 */
export const isMacNative = isMacAppWebView || isMacAppBrowserWebView;
/**
 * 判断为Mac迅雷的内置搜索浏览器
 */
export const isMacThunderBrowser = /thunderbrowser/i.test(ua);
/**
 * 判断为Mac迅雷是否为Mac App Store 版本
 * 版本号说明：中位版本号第二位区分渠道（0：官网版，1：MAS版）, 如5.20.x 为官网版本，5.21.x 为Mas版本
 */
export const isMasMacApp = Number((((_c = (_b = (_a = ua.match(/MacThunder\/([\d\.]+)/)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('.')) === null || _c === void 0 ? void 0 : _c[1]) || '').padEnd(2, '0')) %
    2 !==
    0 || false;
// ======================================================================================================================
/**
 * Windows PC 迅雷客户端 webview的判断。
 * （注意：如果是web开发的客户端插件，比如群组聊天，是集成到客户端里面，那这个判断会是 false）
 */
const isWindowsXunleiPcWebview = isBrowser ?
    /Thunder/i.test(ua) && !!window.native && !!window.native.DetachNativeEvent : false;
/**
 * 【已废弃】【已废弃】已废弃，不推荐使用！！已废弃，不推荐使用！！但不能移除，担心影响旧版本。
 */
export const isPC = isWindowsXunleiPcWebview;
/**
 * 是否在迅雷11内。
 * 请使用这个，语义更明确！！
 */
export const isPCNative = isWindowsXunleiPcWebview;
/**
 * 迅雷11内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isPCAppWebView = isWindowsXunleiPcWebview && !/TBC/i.test(ua);
export const isPCAppBrowserWebView = isWindowsXunleiPcWebview && /TBC/i.test(ua);
/**
 * 是否支持xbase 的XBase Jsbridge
 */
export const isXbaseNative = isBrowser ? !!window.XBaseObject : false;
/**
 * 是否为微信内置浏览器
 */
export const isWX = /micromessenger/gi.test(ua);
/**
 * 是否为QQ内置浏览器
 */
export const isQQ = /qq\/([\d.]+)/gi.test(ua);
//# sourceMappingURL=data:application/json;base64,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